import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "card-container",
  class: "container center-div fullscreen-sm p-0-sm"
}
const _hoisted_2 = {
  "data-background-color": "orange",
  class: "card card-signup fullscreen-sm"
}
const _hoisted_3 = { class: "center-div-sm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "social-line mt-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/icons/full-logo.svg",
      width: "186",
      height: "130",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title title-up" }, "Accedi")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "form-group no-border input-group" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "input-group-prepend" }
const _hoisted_9 = { class: "input-group-text users_circle-08 fix-now-icons" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("input", {
  type: "email",
  "aria-describedby": "addon-right addon-left",
  name: "email",
  placeholder: "Email",
  class: "form-control",
  required: ""
}, null, -1)
const _hoisted_11 = { class: "form-group no-border input-group" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "input-group-prepend" }
const _hoisted_14 = { class: "input-group-text text_caps-small fix-now-icons" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("input", {
  type: "password",
  "aria-describedby": "addon-right addon-left",
  name: "password",
  placeholder: "Password",
  class: "form-control",
  required: ""
}, null, -1)
const _hoisted_16 = { class: "card-footer text-center" }
const _hoisted_17 = ["disabled"]

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from '@fortawesome/fontawesome-svg-core'
import {faLock} from '@fortawesome/free-solid-svg-icons'
import {faUser} from '@fortawesome/free-solid-svg-icons'


import {defineComponent} from 'vue';
import $ from 'jquery';
import Swal from "sweetalert2";

const __default__ = defineComponent({
  name: 'Login',
  data() {
    return {
      submitStatus: false,
    }
  },
  props: {
    msg: String,
  },
  methods: {
    warning(title: any, text: any, icon: any) {
      Swal.fire({
        title: title,
        text: text,
        icon: icon,
      }).then(function() {
        window.location.reload();
      });
    },
    email(title: any, text: any, icon: any) {
      Swal.fire({
        title: title,
        text: text,
        icon: icon,
      })
    },
    submit(submitEvent: { target: { elements: { email: { value: any; }; password: { value: any; }; }; }; }) {
      this.login(submitEvent.target.elements.email.value, submitEvent.target.elements.password.value);
    },
    login(email: string, password: string | Blob) {
      let fun = this;
      if (this.isEmail(email)) {
        $("#card-container").addClass("d-none");
        $(".loader-container").removeClass("d-none");
        this.submitStatus = true;
        const formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);

        $.ajax({
          type: 'POST',
          url: "https://romanafuni.xdefcon.com/api/auth/login",
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          beforeSend: function () {
          },
          complete: function () {
          },
          success: (data: any) => {
            this.setCookie("token", "Bearer " + data.data.token);
            window.location.replace("/#/badge");
          },
          error: function (HttpRequest: any) {
            if (HttpRequest.status == 401) {
              fun.warning("Credenziali non valide", "Le credenziali inserite non sono corrette. Si prega di riprovare o contattare l'amministrazione per richiedere il reset della password.!", "warning");
            } else {
              fun.warning("Qualcosa è andato storto", "Assicurati di essere connesso ad Internet e riprova", "warning");
            }
          },

        });
      } else {
        fun.email("Email non valida", "L'indirizzo email fornito non è valido. Si prega di verificare l'indirizzo inserito e riprovare.", "warning");
      }
    },
    setCookie(name: string, value: string) {
      let CookieDate = new Date;
      CookieDate.setFullYear(CookieDate.getFullYear() +10);
      document.cookie = name + '=' + value + '; expires='+ CookieDate.toUTCString() +' ;Path=/;';
    },

    isEmail(email: string) {
      let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    },
    getCookie(name: any) {
      return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
    },
    attemptLogin(){
      if (this.getCookie("token")){
        window.location.replace("/#/badge");
      }
    }
  },
  beforeMount() {
    $(".loader-container").addClass("d-none");
    this.attemptLogin();
    $("#card-container").removeClass("d-none");
  }
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    msg: {}
  },
  setup(__props: any) {


library.add(faLock, faUser)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "row fullscreen-sm m-0-sm",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("i", _hoisted_9, [
                    _createVNode(_unref(FontAwesomeIcon), {
                      icon: ['fas', 'user'],
                      class: "mr-10"
                    })
                  ])
                ]),
                _hoisted_10
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("i", _hoisted_14, [
                    _createVNode(_unref(FontAwesomeIcon), {
                      icon: ['fas', 'lock'],
                      class: "mr-10"
                    })
                  ])
                ]),
                _hoisted_15
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.submitStatus,
                class: "btn btn-round btn-neutral btn-lg"
              }, " Accedi", 8, _hoisted_17)
            ])
          ])
        ])
      ])
    ], 32)
  ]))
}
}

})